import {
  type TFaqPageType,
  type TFaqPageTypeForm,
  type TFaqPageTypeRequest,
  type TFaqPageTypeResponse
} from '../types/faqPageType.types';

export const faqPageTypeMapperFromResponse = (
  response: TFaqPageTypeResponse
): TFaqPageType => {
  return {
    code: response.code,
    name: response.name,
    position: response.position,
    uuid: response.uuid
  };
};

export const faqPageTypeMapperToForm = (
  faqPageType: TFaqPageType
): TFaqPageTypeForm => {
  return {
    code: faqPageType.code.toString(),
    name: faqPageType.name,
    position:
      faqPageType.position !== null ? faqPageType.position.toString() : null,
    uuid: faqPageType.uuid
  };
};

export const faqPageTypeMapperToRequest = (
  faqPageType: TFaqPageTypeForm
): TFaqPageTypeRequest => {
  return {
    code: faqPageType.code,
    name: faqPageType.name,
    position: Number(faqPageType.position || 0),
    uuid: faqPageType.uuid
  };
};
